import Service from '../Service';

const patient = {

    getAllPatient(page) {
        let p = page ? page : 1;
        return Service.get(`/api/patient?page=${p}`)
    },
    getPatient(id) {
        return Service.get(`/api/patient?id=${id}`)
    },
    getPatientdatetime(start_date,end_date,start_time,end_time,start_die,end_die,district) {
        return Service.get(`/api/patient?start_date=${start_date}&end_date=${end_date}&start_time=${start_time}&end_time=${end_time}&start_die=${start_die}&end_die=${end_die}&district=${district}`)
    }
};
export default patient;
